module.exports = __webpack_public_path__ + "fb-tutorial-3-pl.png?d2cc8bbfbd809a1eb302d0d9d8f366bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-3-pl.png
// module id = y4Ml
// module chunks = 50